import React from "react";
import Navigator from "../../../components/navigator/Navigator";
import {useNavigate} from "react-router-dom";

export const MessagingLimitSection = ({ id }: { id: string }) => {
    const navigate = useNavigate();
    return (
        <>
            <div className="description">
                WhatsApp applies daily messaging limits based on your business verification status and recent message volume. These limits control how many unique recipients you can message every 24 hours.
            </div>
            <table>
                <thead><td>Tier</td><td>Limit per 24h</td><td>Common Reason</td></thead>
                <tr><td>Pre-Tier</td><td>250 recipients</td><td>Whatsapp Business Account not yet verified</td></tr>
                <tr><td>Tier 1</td><td>1,000</td><td>Default after verification</td></tr>
                <tr><td>Tier 2</td><td>10,000</td><td>Active, high-quality usage</td></tr>
                <tr><td>Tier 3</td><td>100,000</td><td>Sustained message volume</td></tr>
                <tr><td>Tier 4</td><td>Unlimited</td><td>For large-scale businesses</td></tr>
            </table>
            <div className="sub-title">How to Increase Your Limit</div>
            <div className="sub-section">
                <ol>
                    <li>
                        <div>
                            <div>Complete Business Verification:</div>
                            <div>Go to your <a href="https://business.facebook.com/settings/" target="_blank">Meta Business Settings</a>.</div>
                            <div>click Business Info and complete the Business Verification process (Upload docs, verify phone/email etc.)</div>
                        </div>
                    </li>
                    <li>
                        <div>
                            <div>Accept WhatsApp Terms:</div>
                            <div>Go to your <a href="https://business.facebook.com/settings/" target="_blank">Meta Business Settings</a>.</div>
                            <div>{`Go to Accounts > WhatsApp Accounts`} and click on your WhatsApp Business Account.</div>
                            <div>Accept the WhatsApp Business Terms</div>
                        </div>
                    </li>
                    <li>
                        <div>
                            <div>Get at Least One Template Approved:</div>
                            <div>Create a new automation and message template from the <a onClick={() => navigate('/automations')}>Automations</a> page</div>
                            <div>Wait for it to be approved.</div>
                        </div>
                    </li>
                    <li>
                        <div>
                            <div>Send template messages to as many unique customers as your current tier allows.</div>
                            <div>To upgrade tiers:</div>
                            <div>To Tier 2: message at least 500 unique recipients within 7 days</div>
                            <div>To Tier 3: message at least 5,000 recipients</div>
                            <div>To Tier 4: message at least 50,000 recipients</div>
                            <div>* Meta automatically reviews your activity and upgrades your tier every 24 hours, if eligible.</div>
                        </div>
                    </li>
                </ol>
            </div>
            <div className="sub-section">
                <div>Still stuck at 250/day? This usually means:</div>
                <div>Your business hasn’t completed verification</div>
                <div>You haven’t accepted WhatsApp Business Terms</div>
                <div>Your templates haven’t been used yet</div>
            </div>
            <br />
            <div className="sub-section">
                <div>Helpful Links:</div>
                <div><a href="https://www.facebook.com/business/help/2058515294227817" target="_blank">Business Verification Guide</a></div>
                <div><a href="https://www.facebook.com/legal/terms/whatsapp-business" target="_blank">WhatsApp Business Terms</a></div>
                <div><a onClick={() => navigate("/automations")}>Automations & Templates</a></div>
                <div><a href="https://business.facebook.com/settings/" target="_blank">Check WABA Setup Status (Meta)</a></div>
            </div>
        </>
    );
}